import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslationService, I18nModule } from '@spartacus/core';
import { FaceidmodalComponent } from '../../custom-login/custom-login-form/faceidmodal/faceidmodal.component';
import { GigyaService } from 'src/app/services/gigya.service';
import { CustomLoginService } from '../../custom-login/custom-login-form/custom-login.service';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { CommonPageBreadcrumbsComponent } from '../../../shared/components/common-page-breadcrumbs/common-page-breadcrumbs.component';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-biometric-and-security',
    templateUrl: './biometric-and-security.component.html',
    styleUrl: './biometric-and-security.component.scss',
    imports: [CommonPageBreadcrumbsComponent, NgIf, I18nModule]
})
export class BiometricAndSecurityComponent implements OnInit{
  constructor( private translation: TranslationService,private ModalService:NgbModal,
     private gigyaService: GigyaService, private loginservice:CustomLoginService,
     private userAccountFacade: UserAccountFacade,
    private cd: ChangeDetectorRef){}
  title:any;
  navigationData:any;
  enableBiometric =false;
  enableLoader:boolean = false;
ngOnInit(): void {
   this.translation.translate('breadcrumb.biometricAndSecurity.pageTitle').subscribe(res => {
      this.title = res;
    });
    this.translation.translate('breadcrumb.biometricAndSecurity.breadcrumb').subscribe(res => {
      this.navigationData = res;
    });
    this.enableLoader = true;
    this.gigyaService.getCredentials().then((res)=>{
      this.enableLoader = false;
      this.cd.detectChanges();
      if(res.credentials &&  res.credentials.length > 0){
        this.enableBiometric = true;
      }else{
        this.enableBiometric = false;
      }
    }).catch((err)=>{
      this.enableBiometric = false;
      this.enableLoader = false;
    })
}
enableDisablebiometric(){
  if(this.enableBiometric == false){
    const ModalRef = this.ModalService.open(FaceidmodalComponent, { centered: true, size: 'sm' });
    ModalRef.componentInstance.modaltoopen = 'afterOTPSubmit';
    ModalRef.componentInstance.logindetails = this.gigyaService.getData;
    ModalRef.result.then((result) => {
      if(result === 'success'){
        this.enableBiometric = true;
         this.userAccountFacade.get().subscribe(data => {
          let userId = data?.uid;
              this.loginservice.updateBiometricRegistration(true,userId).subscribe(res=>{
          console.log('biometrics status updated in commerce');
        },err=>{
          console.log('error in updating biometrics status in commerce');
        })  

         });
      }
      else{
        this.enableBiometric = false;
        this.cd.detectChanges();
      }
    })
  }else{
    const ModalRef = this.ModalService.open(FaceidmodalComponent, { centered: true, size: 'sm' });
    ModalRef.componentInstance.modaltoopen = 'disableFingerprint';
    ModalRef.result.then((result) => {
      if(result === 'success'){
        this.enableBiometric = false;
        this.userAccountFacade.get().subscribe(data => {
          let userId = data?.uid;
              this.loginservice.updateBiometricRegistration(false,userId).subscribe(res=>{
          console.log('biometrics status updated in commerce');
        },err=>{
          console.log('error in updating biometrics status in commerce');
        })  

         });
      }
      else{
        this.enableBiometric = true;
        this.cd.detectChanges();
      }
    });
  }

}
}
